{
  "version": 1,
  "asset_id": "cb3edb71-fae5-4f6f-92fe-af808aeaccc4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cb3edb71-fae5-4f6f-92fe-af808aeaccc4/sleeve-to-bypass-completed-en-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cb3edb71-fae5-4f6f-92fe-af808aeaccc4/sleeve-to-bypass-completed-en-640.webp",
  "original_filename": "sleeve-to-bypass-completed-en-640.webp",
  "size": 32388,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:46:29Z"
}
